// @ts-ignore
__webpack_public_path__ = window.env.site_url + '/';
